// extracted by mini-css-extract-plugin
export default {"stars":"CourseRatingSection_stars__R-rPm","footer":"CourseRatingSection_footer__miM27"};